// automatically generated by the FlatBuffers compiler, do not modify

/* eslint-disable @typescript-eslint/no-unused-vars, @typescript-eslint/no-explicit-any, @typescript-eslint/no-non-null-assertion */

export enum EarthquakeProtectionStatus {
  Normal = 0,
  Run = 1,
  Recall = 2,
  Freeze = 3,
  RecallNextFloor = 4,
  Invalid = 5
}
